import {
  Facebook,
  Linkedin,
  Twitter,
  Vimeo,
  Github,
  Website,
} from "../../../../svgIcons"

const renderType = {
  facebook: Facebook,
  linkedin: Linkedin,
  twitter: Twitter,
  vimeo: Vimeo,
  github: Github,
  website: Website,
}
export const ProfileLink = ({ linkType, linkUrl, customClass }) => {
  const Comp = renderType[linkType] || null
  return (
    <a rel="noopener noreferrer" target="_blank" href={linkUrl}>
      {Comp !== null ? (
        <Comp className={`${customClass} w-8 h-8 hover:text-primary`} />
      ) : (
        linkType
      )}
    </a>
  )
}
